<template>
    <v-card id="container">
        <v-card id="title">
            <v-card-title>Respuesta sobre encuestas</v-card-title>
        </v-card>
        <v-card id="filters" class="pa-4">
            <v-card-title>Filtros</v-card-title>
            <v-card-text>
                <v-row class="align-center">
                    <v-col cols="12" md="2">
                        <date-picker
                            label="Desde"
                            v-model="filters.startDate"
                        ></date-picker>
                    </v-col>
                    <v-col cols="12" md="2">
                        <date-picker
                            label="Hasta"
                            v-model="filters.endDate"
                            @input="(value) => {
                                const date = new Date(value)
                                date.setHours(23, 59, 59, 999)
                                filters.endDate = date.toISOString()
                            }"
                        ></date-picker>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-autocomplete
                            dense
                            prepend-inner-icon="mdi-poll"
                            label="Encuesta"
                            v-model="filters.survey"
                            :items="surveyItems"
                            :multiple="tab === 1"
                            :chips="tab === 1"
                            clearable
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-checkbox
                            label="Mostrar solo ordenes validas"
                            v-model="filters.isValidOrderId"
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-checkbox
                            label="Mostrar ordenes duplicadas"
                            v-model="filters.hasOrderIdBeenUsed"
                        ></v-checkbox>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card id="content" class="pa-4">
            <v-tabs v-model="tab" @change="handleTabChange" align-with-title>
                <v-tabs-slider color="black"></v-tabs-slider>
                <v-tab v-for="tabTitle in tabs" :key="tabTitle">{{ tabTitle }}</v-tab>
            </v-tabs>
            <v-card-text>
                <template v-if="tab === 0">
                    <v-alert type="info" v-if="!filters.survey">Debes seleccionar una encuesta para poder ver las estadísticas.</v-alert>
                    <survey-responses-statistics v-else
                        :needUpdate="surveyResponsesStatisticsNeedUpdate"
                        @update:needUpdate="surveyResponsesStatisticsNeedUpdate = $event"
                        :filters="filters"
                        :survey-selected="surveyItems.find(survey => survey.value === filters.survey) || null"
                    ></survey-responses-statistics>
                </template>
                <template v-else>
                    <survey-responses-table
                        :needUpdate="surveyResponsesTableNeedUpdate"
                        @update:needUpdate="surveyResponsesTableNeedUpdate = $event"
                        :filters="filters"
                        @view-response="viewResponse($event)"
                    ></survey-responses-table>
                    <survey-response-info
                        :value="showSurveyResponseInfo"
                        @input="showSurveyResponseInfo = $event"
                        :survey="surveyToShow"
                    ></survey-response-info>
                </template>
            </v-card-text>
        </v-card>
    </v-card>
</template>

<script>
    import DatePicker from './DatePicker.vue'
    import SurveysProvider from '../../../providers/SurveysProvider'

    import SurveyResponsesStatistics from './SurveyResponsesStatistics.vue'
    import SurveyResponsesTable from './SurveyResponsesTable.vue'
    import SurveyResponseInfo from './SurveyResponseInfo.vue'

    export default {
        name: "SurveyResponsesPage",
        components: { DatePicker, SurveyResponsesStatistics, SurveyResponsesTable, SurveyResponseInfo },
        data: () => ({
            filters: {
                startDate: null,
                endDate: null,
                survey: null,
                isValidOrderId: false,
                hasOrderIdBeenUsed: false
            },
            surveyFiltersLoading: false,
            surveyItems: [],
            tab: 0,
            tabs: ['Estadísticas', 'Listado'],
            surveyResponsesStatisticsNeedUpdate: false,
            surveyResponsesTableNeedUpdate: false,
            showSurveyResponseInfo: false,
            surveyToShow: null,
            viewResponseLoading: false
        }),
        methods: {
            async fetchSurveyItems(){
                try {
                    this.surveyFiltersLoading = true
                    const {data: {fetchSurvey}} = await SurveysProvider.fetchSurvey()
                    this.surveyItems = fetchSurvey.map(survey => ({
                        text: survey.name,
                        data: survey,
                        value: survey.id
                    }))
                } catch (error) {
                    console.error("Error fetching survey items:", error)
                } finally {
                    this.surveyFiltersLoading = false
                }
            },
            handleTabChange(tab){
                if(tab === 1 && this.filters.survey) this.filters.survey = [this.filters.survey]
                if(tab === 0 && this.filters.survey && this.filters.survey.length) this.filters.survey = this.filters.survey[0]
                if(tab === 0 && this.filters.survey && !this.filters.survey.length) this.filters.survey = null
            },
            async viewResponse(responseItem){
                this.showSurveyResponseInfo = true
                this.surveyToShow = responseItem
            }
        },
        mounted() {
            this.fetchSurveyItems()
        },
        watch: {
            filters: {
                handler() {
                    this.surveyResponsesStatisticsNeedUpdate = true
                    this.surveyResponsesTableNeedUpdate = true
                },
                deep: true
            }
        }
    }
</script>


